import { gql } from '@apollo/client';

export const AddUserAvatar = gql`
  mutation AddUserAvatar($image: Upload!) {
    addUserAvatar(input: { Attachment: $image })
      @rest(type: "File", path: "/UserAvatar", method: "POST", bodySerializer: "fileEncode") {
      errors {
        ...Error
      }
    }
  }
`;

export const RemoveUserAvatar = gql`
  mutation RemoveUserAvatar {
    removeUserAvatar @rest(type: "File", path: "/UserAvatar", method: "DELETE") {
      errors {
        ...Error
      }
    }
  }
`;
